module.exports = __webpack_public_path__ + "img/world.f32dcc0d.png";